// extracted by mini-css-extract-plugin
var _1 = "SectionPlaneSearch_root__ae63b";
export { _1 as "root" }
